import { createRouter, createWebHashHistory } from 'vue-router';

import Search from './routes/Search'

const routes = [
  { path: '/', name: 'Search', component: Search }
//  { path: '/resources', name: 'Resources', component: Resources },
//  { path: '/my-cases', name: 'MyCases', component: MyCases },
//  { path: '/notifications', name: 'Notifications', component: Notifications },
//  { path: '/calendar', name: 'Calendar', component: Calendar }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router